import { render } from "./ChatContainer.vue?vue&type=template&id=0325a6da&scoped=true"
import script from "./ChatContainer.vue?vue&type=script&lang=js"
export * from "./ChatContainer.vue?vue&type=script&lang=js"

import "./ChatContainer.vue?vue&type=style&index=0&id=0325a6da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0325a6da"

export default script